import { Service, Services } from "../../../models/Service";
import { useAPI } from "../useAPI";
import endpoints from "./services.endpoint";
import { ServicesResponse } from "./services.type";

export const useServices = () => {
  return useAPI<ServicesResponse, Services>(
    endpoints.GET_SERVICES,
    responseToModel,
    {},
  );
};

const responseToModel = (response: ServicesResponse): Services => {
  const servicesList = response.services.map((service) =>
    new Service(
      service.id,
      service.name,
      service.description,
    )
  );
  return new Services(servicesList);
};
